<div class="table-responsive">
    <div class="flex-container">
        <h4>{{ '@dvirDetail' | translate }}</h4>
        <div class="flex-spacer"></div>
        <div class="flex align-flex-right">
            <button mat-raised-button color="primary"
                title="{{'@openVehicleDetails' | translate }}" (click)="goToVehicleDetail()">{{
                '@vehicleDetails' | translate }}</button>
        </div>
    </div>
    <div *ngIf="loading" class="loading-strip">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div class="flex align-flex-middle icon-with-text red-banner" *ngIf="dvir && dvir.isFalseClean">
        <mat-icon class="make-white">warning</mat-icon>
        <span class="banner-text make-white">
            {{ dvir.falseCleanReason }}
        </span>
    </div>
    <mat-tab-group #tabGroup animationDuration="100ms" [selectedIndex]="selectedIndex"
        (selectedIndexChange)="selectedIndexChanged($event)" *ngIf="!loading">
        <mat-tab label="{{ '@details' | translate }}">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div class="flex-container">
                            <div *ngIf="dvir">
                                <form [formGroup]="dvirForm">
                                    <mat-form-field class="padded-input third-sized">
                                        <mat-label>{{ '@vin' | translate }}</mat-label>
                                        <input matInput class="text-black" formControlName="vin">
                                    </mat-form-field>
                                    <mat-form-field class="padded-input third-sized">
                                        <mat-label>{{ '@dvirCreateDateTimeUtc' | translate }}</mat-label>
                                        <input matInput
                                            value="{{ dvir.dvirCreateDateTimeUtc | localizedDate: 'medium' }}" disabled
                                            class="text-black">
                                    </mat-form-field>
                                    <mat-form-field class="padded-input third-sized">
                                        <mat-label>{{ '@logType' | translate }}</mat-label>
                                        <input matInput class="text-black" formControlName="logType">
                                    </mat-form-field>
                                    <mat-form-field class="padded-input third-sized">
                                        <mat-label>{{ '@notes' | translate }}</mat-label>
                                        <input matInput class="text-black" formControlName="notes">
                                    </mat-form-field>
                                    <mat-form-field *ngIf="telematicDriver$ | async; let telematicDriverDict"
                                        class="padded-input third-sized">
                                        <mat-label>{{ '@driver' | translate }}</mat-label>
                                        <input matInput
                                            value="{{displayDriver(telematicDriverDict, dvir.driver, dvir.telematicProvider)}}"
                                            disabled class="text-black">
                                    </mat-form-field>
                                    <mat-form-field class="padded-input third-sized">
                                        <mat-label>{{ '@isSafeToOperate' | translate }}</mat-label>
                                        <input hidden matInput class="text-black" formControlName="isSafeToOperate">
                                        <span
                                            [ngClass]="{ 'fas': true, 'fa-check green': (dvir?.isSafeToOperate), 'fa-times red': !(dvir?.isSafeToOperate)} ">
                                        </span>
                                    </mat-form-field>
                                    <fieldset *ngIf="!(dvir.defectList.length > 0)" class="fborder">
                                        <h5>{{ '@noDefects' | translate }}</h5>
                                    </fieldset>
                                    <fieldset *ngIf="dvir.defectList.length > 0" class="fborder">
                                        <h5>{{ '@defectList' | translate }}</h5>
                                        <table mat-table [dataSource]="defectDataSource">
                                            <ng-container matColumnDef="component">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    {{ '@component' | translate }}
                                                </th>
                                                <td mat-cell *matCellDef="let defect">
                                                    {{ defect?.component }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="notes">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    {{ '@notes' | translate }}
                                                </th>
                                                <td mat-cell *matCellDef="let defect" class="breakWord">
                                                    {{ defect?.notes }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="repairStatus">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    {{ '@repairType' | translate }}
                                                </th>
                                                <td mat-cell *matCellDef="let defect">
                                                    {{ defect?.repairStatus }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="repairDateTimeUtc">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    {{ '@repairDateTimeUtc' | translate }}
                                                </th>
                                                <td mat-cell *matCellDef="let defect">
                                                    {{defect?.repairDateTimeUtc | localizedDate: 'medium'}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="repairedBy">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    {{ '@repairedBy' | translate }}
                                                </th>
                                                <td mat-cell *matCellDef="let defect">
                                                    <div *ngIf="telematicDriver$ | async; let telematicDriverDict">
                                                        {{displayDriver(telematicDriverDict, dvir.repairedBy,
                                                        dvir.telematicProvider)}}
                                                    </div>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row
                                                *matHeaderRowDef="['component','notes','repairStatus','repairedBy','repairDateTimeUtc']">
                                            </tr>
                                            <tr mat-row
                                                *matRowDef="let row; columns: ['component','notes','repairStatus','repairedBy','repairDateTimeUtc']">
                                            </tr>
                                        </table>
                                    </fieldset>
                                    <mat-form-field
                                        *ngIf="dvir?.certifiedBy && telematicDriver$ | async; let telematicDriverDict"
                                        class="padded-input third-sized">
                                        <mat-label>{{ '@certifiedBy' | translate }}</mat-label>
                                        <input matInput
                                            value="{{displayDriver(telematicDriverDict, dvir.certifiedBy, dvir.telematicProvider)}}"
                                            disabled class="text-black">
                                    </mat-form-field>
                                    <mat-form-field *ngIf="dvir?.certifiedDateTimeUtc" class="padded-input third-sized">
                                        <mat-label>{{ '@certifiedDateTimeUtc' | translate }}</mat-label>
                                        <input matInput
                                            value="{{ dvir.certifiedDateTimeUtc | localizedDate: 'medium' }}" disabled
                                            class="text-black">
                                    </mat-form-field>
                                </form>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>